import { Component } from '@angular/core';

@Component({
	selector: 'app-delete-intake-form-modal',
	templateUrl: './delete-intake-form-modal.component.html',
	standalone: true,
})
export class DeleteIntakeFormModalComponent {}
